export type NiyaazBookedSlotsConfig = {
  minDay: number;
  maxDay: number;
  slots: readonly string[];
  slotLabels: Record<string, string>;
  getDayLabel: (day: number) => string;
  getDayButtonLabel: (day: number) => string;
  sectionTitle: string;
  selectDaySubtitle: string;
  dayColumnHeader: string;
  fullDayLegend: string;
};

const SHEHRULLA_CONFIG: NiyaazBookedSlotsConfig = {
  minDay: 1,
  maxDay: 31,
  slots: ["SEHORI", "IFTAARI", "NIYAAZ"],
  slotLabels: {
    SEHORI: "Sehori",
    IFTAARI: "Iftaari",
    NIYAAZ: "Niyaaz",
  },
  getDayLabel: (day) => (day === 31 ? "EID Ul Fitr" : `Raat ${day}`),
  getDayButtonLabel: (day) => (day === 31 ? "EID" : String(day)),
  sectionTitle: "Booked Slots (Ramadaan Days 1–30)",
  selectDaySubtitle: "Select Raat (1–30 for Ramadaan) and Slot",
  dayColumnHeader: "Raat",
  fullDayLegend: "Full (niyaaz ≥1 e.g. 1 full / 2 half / 4 quarter + 1 iftari)",
};

const ASHARA_CONFIG: NiyaazBookedSlotsConfig = {
  minDay: 2,
  maxDay: 10,
  slots: ["LUNCH", "DINNER"],
  slotLabels: {
    LUNCH: "Lunch",
    DINNER: "Dinner",
  },
  getDayLabel: (day) => `Day ${day}`,
  getDayButtonLabel: (day) => String(day),
  sectionTitle: "Booked Slots (Days 2–10)",
  selectDaySubtitle: "Select Day (2–10) and Slot",
  dayColumnHeader: "Day",
  fullDayLegend: "Full (lunch ≥1 and dinner ≥1, e.g. 1 full each or 2 half each)",
};

export function getNiyaazBookedSlotsConfig(isAshara: boolean): NiyaazBookedSlotsConfig {
  return isAshara ? ASHARA_CONFIG : SHEHRULLA_CONFIG;
}

type SlotBooking = { type?: string };

type DaySlotData = {
  slot: string;
  type: string;
  bookings?: SlotBooking[];
  usedCapacity?: number;
};

const BOOKING_TYPE_MULTIPLIER: Record<string, number> = {
  QUARTER: 0.25,
  HALF: 0.5,
  FULL: 1,
};

function sumBookingCapacity(bookings: SlotBooking[]): number {
  return bookings.reduce((sum, booking) => {
    const mult = BOOKING_TYPE_MULTIPLIER[booking.type ?? "FULL"] ?? 1;
    return sum + mult;
  }, 0);
}

export function isAsharaDayFull(
  dayData: { slots?: DaySlotData[] },
  config: NiyaazBookedSlotsConfig
): boolean {
  const slots = dayData.slots || [];
  const getUsed = (slotName: string) =>
    slots
      .filter((s) => s.slot === slotName)
      .reduce((sum, s) => {
        if (s.usedCapacity != null) return sum + s.usedCapacity;
        return sum + sumBookingCapacity(s.bookings ?? []);
      }, 0);

  if (config.slots.includes("NIYAAZ")) {
    return getUsed("NIYAAZ") >= 1 && getUsed("IFTAARI") >= 1;
  }
  return getUsed("LUNCH") >= 1 && getUsed("DINNER") >= 1;
}
